export class InvitationModel {
    email: string;
    role: string;
    message: string;
    language: string;
    agency_id: number;

    client_id: number;

    constructor() {
      this.email = '';
      this.role = '';
      this.message = '';
      this.language = '';
      this.agency_id = 0;
      this.client_id = null;
    }
}
